import { Box, BoxProps, Heading, Image, Text } from "@chakra-ui/react";
import { Leg } from "~/api/resources/Itineraries";
import { PinSolid } from "~/images/svgs";
import { useSlideContext } from "../../Slider";
import { useIsMobile } from "~/lib/hooks";
import { useLegContext } from "./LegProvider";

type Props = BoxProps & {
  leg: Leg;
  isLast?: boolean;
};
export const LegCard = ({ leg, isLast, ...props }: Props) => {
  const { stops, title } = leg;
  const { isActive } = useSlideContext();
  const isMobile = useIsMobile();
  const { isEast, toggleDirection } = useLegContext();
  const compassImage = isEast ? "/eastWestCompass.png" : "/westEastCompass.png";
  return (
    <Box>
      <Box
        padding={{ base: "32px" }}
        borderRadius="10px"
        bgColor="white"
        w={{ md: "265px" }}
        border="2px solid"
        borderColor={isActive && isMobile ? "yellow.500" : "white"}
        transition="transform"
        transitionDuration={"0.5s"}
        boxShadow={isActive ? "xl" : "none"}
        // _hover={{ borderColor: "yellow.500" }}
        {...props}
      >
        <Heading fontSize={{ base: "lg" }}>{title}</Heading>

        <Box display="flex" alignItems="center" gap={1}>
          <PinSolid boxSize="12px" />
          <Text fontWeight="thin" fontSize={{ base: "md" }}>
            {stops.length} {stops.length === 1 ? "stop" : "stops"}
          </Text>
        </Box>
      </Box>
      {!isLast && (
        <Box borderRight="3px dashed" bgColor="grey.900" h={50} w={"50%"}></Box>
      )}
      {isLast && (
        <Box margin={5} display="flex" justifyContent="center">
          <Image
            h={30}
            w={30}
            src={compassImage}
            alt="compass"
            onClick={toggleDirection}
          />
        </Box>
      )}
    </Box>
  );
};
